import { useField } from "formik";
import TextField from "@mui/material/TextField";
import DateTimeNodeType from "../../types/DateTimeNodeType";

const DateTimeNode = ({ name, label, required, size, ...props }: any & DateTimeNodeType) => {
  const [field, meta] = useField(name);

  return (
      <TextField
          {...field}
          size={size || 'small'}
          type="datetime-local"
          label={label}
          fullWidth
          required={required}
          InputLabelProps={{ shrink: true }}
          error={meta.touched && Boolean(meta.error)}
          helperText={meta.touched && meta.error}
          {...props}
      />
  );
};

export default DateTimeNode;